import { Meta, MetaDefinition, Title } from '@angular/platform-browser'
import { ThemeService, ThemeType } from './theme.service'
import { Inject, Injectable } from '@angular/core'
import { LocaleService, StorageService, WindowService } from 'shared-services'
import { metaTagsToken } from '../providers/meta-tags.token'

@Injectable({ providedIn: 'root' })
export class PageService {
  public constructor(
    private readonly metaTagService: Meta,
    @Inject(metaTagsToken) private readonly metaTags: MetaDefinition[],
    private readonly htmlTitleElementService: Title,
    private readonly storageService: StorageService,
    private readonly themeService: ThemeService,
    private readonly windowService: WindowService,
    private readonly localeService: LocaleService,
  ) {}

  public setPageTitle(title: string): void {
    this.htmlTitleElementService.setTitle(title)
  }

  public addMetaTags(): void {
    this.metaTagService.addTags(this.metaTags)
  }

  public setInitialTheme(): void {
    const theme = this.storageService.getItemStr(
      ThemeService.LOCAL_STORAGE_KEY,
    ) as ThemeType

    if (theme) {
      this.themeService.setTheme(theme)
      return
    }

    const preferredTheme = this.windowService.prefersColorSchemeMatch('Light')
      ? 'Light'
      : 'Dark'

    this.themeService.setTheme('Dark')
  }

  public setInitialLocale(): void {
    if (!this.localeService.isUserLocaleDifferentFromAppLocale()) {
      return
    }

    this.localeService.reload(this.localeService.languageLocale)
  }
}
